<div [formGroup]="editorForm">
  <ca-attached-data-multiple-selector
    formControlName="editor"
    [maxSelectedItems]="config.maxSelectedItems"
    [filters]="filters"></ca-attached-data-multiple-selector>
</div>
